import {
  Download1Stroke,
  PrinterStroke,
  RefreshCircle1ClockwiseStroke,
  Search1Stroke,
  SignPostLeftStroke
} from '@lineiconshq/free-icons';
import { Lineicons } from '@lineiconshq/react-lineicons';
import { ActionBarV2, ActionButtonV2, AritoIcon, MenuButtonV2 } from '@/components/custom/erp';
import { useSoChiTietCongNoContext } from '../context';
import { formatDate } from '@/lib/formatUtils';

interface ActionBarProps {
  onSearchClick?: () => void;
  onRefreshClick?: () => void;
  onPrintClick?: () => void;
  onFixedColumnsClick?: () => void;
  onEditPrintTemplateClick?: () => void;
  className?: string;
  searchFieldStates?: MuaHangRecord;
  searchParams?: MuaHangRecord;
}

export const ActionBar: React.FC<ActionBarProps> = ({
  onSearchClick,
  onRefreshClick,
  onPrintClick,
  onFixedColumnsClick,
  onEditPrintTemplateClick,
  className,
  searchFieldStates,
  searchParams
}) => {
  const { exportToExcel, canExport, isExporting } = useSoChiTietCongNoContext();
  const subtitle = `Từ ngày ${formatDate(searchParams.ngay_ct1)} đến ngày ${formatDate(searchParams.ngay_ct2)}, ${searchFieldStates?.account ? `Tài khoản: ${searchFieldStates?.account?.code}, ` : ''} ${searchFieldStates?.supplier ? `Nhà cung cấp: ${searchFieldStates?.supplier?.customer_code} - ${searchFieldStates?.supplier?.customer_name} ` : ''}`;
  return (
    <ActionBarV2
      className={className}
      titleComponent={
        <div>
          <h1 className='text-xl font-bold'>Sổ chi tiết công nợ theo nhà cung cấp</h1>
          <div className='text-[10px] text-gray-500'>
            <p>
              <span className='mr-2 inline-block h-2 w-2 rounded-full bg-red-600'></span>
              <span className='font-semibold'>{subtitle}</span>
            </p>
          </div>
        </div>
      }
    >
      {onSearchClick && (
        <ActionButtonV2 icon={Search1Stroke} title='Tìm kiếm' onClick={onSearchClick} variant='primary' />
      )}
      <MenuButtonV2
        title='In ấn'
        icon={<Lineicons aria-hidden='true' icon={PrinterStroke} />}
        items={[
          {
            title: 'Sổ chi tiết công nợ',
            icon: <AritoIcon icon={20} />,
            onClick: onEditPrintTemplateClick,
            group: 0
          },
          {
            title: 'Sổ chi tiết công nợ (ngoại tệ)',
            icon: <AritoIcon icon={20} />,
            onClick: onEditPrintTemplateClick,
            group: 0
          }
        ]}
      />
      {/* No print button */}
      {onRefreshClick && (
        <ActionButtonV2
          icon={RefreshCircle1ClockwiseStroke}
          title='Refresh'
          onClick={onRefreshClick}
          variant='destructive'
        />
      )}
      {onFixedColumnsClick && (
        <ActionButtonV2
          icon={SignPostLeftStroke}
          title='Cố định cột'
          onClick={onFixedColumnsClick}
          variant='secondary'
        />
      )}
      <ActionButtonV2
        icon={Download1Stroke}
        title='Kết xuất dữ liệu'
        onClick={exportToExcel}
        variant='secondary'
        disabled={!canExport || isExporting}
        loading={isExporting}
        loadingTitle='Đang kết xuất...'
      />
      <MenuButtonV2
        items={[
          {
            title: 'Chỉnh sửa mẫu in',
            icon: <AritoIcon icon={864} />,
            onClick: onEditPrintTemplateClick,
            group: 0
          }
        ]}
      />
    </ActionBarV2>
  );
};

export default ActionBar;
